import { render, staticRenderFns } from "./AwsAgent.vue?vue&type=template&id=684cc0a9&scoped=true"
import script from "./AwsAgent.vue?vue&type=script&lang=js"
export * from "./AwsAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684cc0a9",
  null
  
)

export default component.exports